<style scoped>
tr:nth-child(odd) {
  background: #f6f6f6;
}
</style>
<template>
  <v-container>
    <v-layout mt-5 xs8>
      <v-flex column wrap xs12 sm12 md11 lg10 xl10>
        <h3>
          <v-icon large color="yellow">vpn_key</v-icon>
          Set new Password
        </h3>
        Here you can set your new password.
        <blockquote>
          Please use the save button to set your new password.
        </blockquote>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 sm12 md11 lg10 xl10>
        <reset-password-confirm-form
          class="pl-5 pr-5 pb-3 pt-2 mt-4"
        ></reset-password-confirm-form>
        <v-flex mt-2 text-xs-right>
          <v-btn class="mr-0" outline color="grey" dark to="/login">
            <v-icon left>lock_open</v-icon>
            Login
          </v-btn>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ResetPasswordConfirmForm from "@/components/ResetPasswordConfirmForm";

export default {
  components: {
    ResetPasswordConfirmForm
  }
};
</script>
